import React from 'react'
import { Modal, Form, Card, Row, Col, Space, Select, Checkbox } from 'antd'
import CoreEnums from '../../../../../../core/utils/enums'

const BookingsFilter = ({
  showFilters,
  setShowFilters,
  additionalFilters,
  setAdditionalFilters, // Corrected prop name from seetAdditionalFilters
  additionalFiltersForm,
  services, // Assuming services comes from redux state, will be passed from parent
  bpmConfig
}) => {
  const statusesOptions = [
    CoreEnums.bookingStatuses.checkin,
    CoreEnums.bookingStatuses.screening,
    CoreEnums.bookingStatuses.consultation,
    CoreEnums.bookingStatuses.reception
  ]

  return (
    <Modal
      onOk={() => {
        let formValues = additionalFiltersForm.getFieldsValue()
        setAdditionalFilters(formValues)
        setShowFilters(false)
      }}
      open={showFilters}
      width={900}
      onCancel={() => setShowFilters(false)}
      destroyOnClose
      title='Booking Filters'
    >
      <Col span={24}>
        <Form form={additionalFiltersForm} initialValues={additionalFilters}>
          <Card type='inner' title='Additional Filters' size='small'>
            <Row gutter={[12, 12]}>
              <Col span={24}>
                <Space>
                  <p style={{ width: 75 }}>
                    <b>Status:</b>
                  </p>
                  <Form.Item style={{ margin: 0 }} name='status'>
                    <Select
                      mode='multiple'
                      placeholder='- Select -'
                      options={statusesOptions.map((status) => ({
                        value: status,
                        label: bpmConfig?.find((e) => e.key === status)?.label || status
                      }))}
                      style={{ minWidth: 250 }}
                    />
                  </Form.Item>
                </Space>
              </Col>
              <Col span={24}>
                <Space>
                  <p style={{ width: 75 }}>
                    <b>Type:</b>
                  </p>
                  <Form.Item style={{ margin: 0 }} name='type'>
                    <Select
                      mode='multiple'
                      placeholder='- Select -'
                      options={[
                        { value: 'standard', label: 'Standard' },
                        { value: 'virtual', label: 'Virtual' }
                      ]}
                      style={{ minWidth: 250 }}
                    />
                  </Form.Item>
                </Space>
              </Col>
              <Col span={24}>
                <Space>
                  <p style={{ width: 75 }}>
                    <b>Service:</b>
                  </p>
                  <Form.Item style={{ margin: 0 }} name='service'>
                    <Select
                      mode='multiple'
                      placeholder='- Select -'
                      options={services.map((service) => ({ value: service._id, label: service.name }))}
                      style={{ minWidth: 250 }}
                    />
                  </Form.Item>
                </Space>
              </Col>
              <Col span={24}>
                <Space>
                  <p>
                    <b>Hide Completed:</b>
                  </p>
                  <Form.Item style={{ margin: 0 }} name='hideCompleted' valuePropName='checked'>
                    <Checkbox />
                  </Form.Item>
                </Space>
              </Col>
              <Col span={24}>
                <Space>
                  <p>
                    <b>Hide Cancelled:</b>
                  </p>
                  <Form.Item style={{ margin: 0 }} name='hideCancelled' valuePropName='checked'>
                    <Checkbox />
                  </Form.Item>
                </Space>
              </Col>
              <Col span={24}>
                <Space>
                  <p>
                    <b>Non-Scheduled Bookings Only:</b>
                  </p>
                  <Form.Item style={{ margin: 0 }} name='nonScheduledOnly' valuePropName='checked'>
                    <Checkbox />
                  </Form.Item>
                </Space>
              </Col>
            </Row>
          </Card>
        </Form>
      </Col>
    </Modal>
  )
}

export default BookingsFilter
